import { formatISO, parseISO } from "date-fns";

export const formatDateString = (isoDateString: string): string => {
  return formatISO(parseISO(isoDateString), {
    representation: "date",
  });
};
